import { Button, HeroLayout, Image, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { Link as RouterLink } from '@change-corgi/core/react/router';

import { useSapContainer } from './hooks/useSapContainer';

export const SapContainer: React.FC = () => {
	const {
		data: { sapImage, sapAiUrl, sapUrl },
		actions: { trackSapAiClick, trackSapClick },
	} = useSapContainer();

	return (
		<HeroLayout
			media={
				<Image
					src={sapImage}
					alt="petition image next to start a petition asks"
					className="h-full w-full object-cover object-top"
				/>
			}
			variant="1/2"
		>
			<div className="bg-gradient-background-dark-1 text-typography-inverse-strong flex flex-col justify-center space-y-5 p-6 md:p-10">
				<Text as="h2" variant="heading" className="mb-1">
					<Translate value="corgi.impact_story.cta.title" />
				</Text>

				<Button
					as={RouterLink}
					data-testid="impact-story-page-sap"
					data-qa="impact-story-page-sap"
					to={sapUrl}
					variant="primary"
					size="small"
					onClick={trackSapClick}
				>
					<Translate value="corgi.impact_story.cta.primary_button" />
				</Button>
				<Button
					as={RouterLink}
					data-testid="impact-story-page-sap-ai"
					data-qa="impact-story-page-sap-ai"
					to={sapAiUrl}
					variant="secondary-inverse"
					size="small"
					onClick={trackSapAiClick}
				>
					<Translate value="corgi.impact_story.cta.secondary_button" />
				</Button>
			</div>
		</HeroLayout>
	);
};
